import { RulesetEnum } from '../enums/RulesetEnum';
import { RegionsEnum } from '../enums/RegionsEnum';
import { PatternEnum } from './PatternEnum';
import { ValveType } from './ValveTypes';

const OCCO = [
    'Open/close',
    'On/off',
    'Changeover',
];

function guessRulesetEU(
    type: ValveType,
    pattern: string,
    operationMode: string,
): RulesetEnum[] {
    switch (true) {
        // PI
        case type === 'Pressure-independent zone valve': {
            return [RulesetEnum.Ruleset4_PIQCV];
        }
        case type === 'Pressure-independent 6-way zone valve': {
            return [RulesetEnum.Ruleset6_PI_6W_EPIV];
        }
        case type === 'Pressure-independent Belimo Energy Valve™':
        case type === 'Electronic pressure-independent characterised control valve': {
            return [RulesetEnum.Ruleset3_PI_EV_EPIV];
        }
        case type === 'Pressure-independent flow limiter valve': {
            return [RulesetEnum.Ruleset100_PIFLV];
        }
        //PD
        case type === '6-way zone valve': {
            if ('Changeover' === operationMode) {
                return [RulesetEnum.Ruleset5_PD_6W_OCCO];
            }
            return [RulesetEnum.Ruleset5_PD_6W];
        }
        case 'Modulating diverting' === operationMode && type === 'Globe valve' && pattern === PatternEnum['3-way']: {
            return [RulesetEnum.Ruleset1_PD_GV_3W_MD];
        }
        case 'Changeover' === operationMode && type === 'Globe valve' && pattern === PatternEnum['3-way']: {
            return [RulesetEnum.Ruleset1_PD_GV_3W_CO];
        }
        case OCCO.includes(operationMode): {
            return [RulesetEnum.Ruleset1_PD_OCCO];
        }
        case type === 'Globe valve': {
            return [RulesetEnum.Ruleset1_PD_GV];
        }
        case type === 'Butterfly valve':
        case type === 'Characterised control valve, ball valve':
        case type === 'Characterised control valve':
        case type === 'Potable water valve': {
            return [RulesetEnum.Ruleset1_PD];
        }
        case type === 'Zone valve': {
            return [RulesetEnum.Ruleset1_PD_QCV];
        }
        default:
            return [];
    }
}

function guessRulesetAM(
    type: ValveType,
    pattern: string,
    operationMode: string,
): RulesetEnum[] {
    switch (true) {
        case type === 'Butterfly Valve' && operationMode === 'On/off': {
            return [RulesetEnum.AM_PD_BFV_OC];
        }
        case type === 'Butterfly Valve': {
            return [RulesetEnum.AM_PD_BFV];
        }

        case type === 'Characterized control valve' && pattern === PatternEnum['6-way']: {
            return [RulesetEnum.AM_PD_6W_CCV];
        }
        case type === 'Globe valve':
        case type === 'Characterized control valve':
        case type === 'Ball valve':
        case type === 'Potable water valve': {
            return [RulesetEnum.AM_PD];
        }
        case type === 'Zone valve': {
            return [RulesetEnum.AM_PD, RulesetEnum.AM_PD_QCV];
        }
        // PI
        case type === 'Electronic pressure-independent characterized control valve' && pattern === PatternEnum['6-way']: {
            return [RulesetEnum.AM_PI_6W];
        }
        case type === 'Pressure-independent zone valve':
        case type === 'Electronic pressure-independent characterized control valve':
        case type === 'Pressure-independent Belimo Energy Valve™': {
            return [RulesetEnum.AM_PI];
        }
        default:
            return [];
    }
}

export function guessRulesetsV2(
    currentRegion: RegionsEnum,
    types: ValveType[],
    patterns: string[],
    operationModes: string[],
): RulesetEnum[] {
    const out: Set<RulesetEnum> = new Set<RulesetEnum>();
    for (const type of types) {
        for (const pattern of patterns) {
            if (operationModes.length === 0) {
                const ruleset = currentRegion === RegionsEnum.am
                    ? guessRulesetAM(type, pattern, '') : guessRulesetEU(type, pattern, '');
                if (ruleset.length > 0) {
                    ruleset.forEach((r) => out.add(r));
                }
            } else {
                for (const operationMode of operationModes) {
                    const ruleset = currentRegion === RegionsEnum.am
                        ? guessRulesetAM(type, pattern, operationMode) : guessRulesetEU(type, pattern, operationMode);
                    if (ruleset.length > 0) {
                        ruleset.forEach((r) => out.add(r));
                    }
                }
            }
        }
    }
    return [...out.values()];
}
